import axios from "@/plugins/axios.js"

const actions = {
  fetchActivities({ commit, state}, payload = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`/activities?${new URLSearchParams(payload).toString()}`)
        .then((response) => {
          if(response.data.success){
            commit('SET_ACTIVITIES', response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  markAsRead({ commit }, actId) {
    return new Promise((resolve, reject) => {
      axios.get(`/activities/${actId}/markasread`)
        .then((response) => {
          if(response.data.success){
            commit('MARK_AS_READ', actId)
          }
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}

const getters = {
  // getItem: state => (productId) => state.products.find((product) => product.id == productId),
}

const state = {
  pageData: {
    data: []
  },
}

const mutations = {
  SET_ACTIVITIES(state, data) {
    state.pageData = data
  },
  ADD_ACTIVITY(state, activity) {
    state.pageData.data.unshift(activity)
  },
  DELETE_ACTIVITY(state, actId) {
    const ItemIndex = state.pageData.data.findIndex((item) => item.id == actId)
    state.pageData.data.splice(ItemIndex, 1)
  },
  MARK_AS_READ(state, actId){
  	state.pageData.data.map((item)=>{
  		if(item.id == actId){
  			return item.is_read = 1
  		}
  	})
  }

}

export default {
  isRegistered: true,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

